import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { PAGES } from '@/app/pages';
import ThemeToggle from './toggles/ThemeToggle';
import LangToggle from './toggles/LangToggle';
import './Nav.css';

export default function Nav() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // close the mobile menu whenever the route changes
  useEffect(() => setOpen(false), [pathname]);

  // lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className="nav" role="banner">
      <Link className="nav-brand" to="/" aria-label={t('nav.brand')}>
        <span className="brand-logo nav-logo" role="img" aria-label={t('nav.brand')} />
      </Link>

      {/* desktop tab switcher */}
      <nav className="nav-tabs" aria-label={t('nav.menu')}>
        {PAGES.map((p) => (
          <NavLink
            key={p.key}
            to={p.path}
            end={p.path === '/'}
            className={({ isActive }) => `nav-tab${isActive ? ' nav-tab--active' : ''}`}
          >
            {t(`nav.pages.${p.key}`)}
          </NavLink>
        ))}
      </nav>

      <div className="nav-actions">
        <LangToggle />
        <ThemeToggle />
        <Link className="nav-cta" to="/contact">
          {t('hero.ctaTalk')}
        </Link>
        <button
          type="button"
          className="nav-burger"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          aria-controls="nav-mobile"
          aria-label={t('nav.menu')}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* mobile menu */}
      <div id="nav-mobile" className={`nav-mobile${open ? ' nav-mobile--open' : ''}`}>
        <ul className="nav-mobile-list">
          {PAGES.map((p) => (
            <li key={p.key}>
              <NavLink
                to={p.path}
                end={p.path === '/'}
                className={({ isActive }) => `nav-mobile-link${isActive ? ' nav-mobile-link--active' : ''}`}
                onClick={() => setOpen(false)}
              >
                {t(`nav.pages.${p.key}`)}
              </NavLink>
            </li>
          ))}
        </ul>
        <Link className="nav-cta nav-mobile-cta" to="/contact" onClick={() => setOpen(false)}>
          {t('hero.ctaTalk')}
        </Link>
      </div>
    </header>
  );
}
